module.exports = __webpack_public_path__ + "static/01-4d57be9fa1f15a6c15d143426ee5a91f.jpg";